import { useUserpilot } from "@platform/hooks/useUserpilot";

import RefreshIcon from "@assets/icons/refresh-icon.svg";
import MeetingSyncIcon from "@assets/icons/meeting-sync-icon.svg";
import MeetingSyncingIcon from "@assets/icons/meeting-syncing-icon.svg";

import usePlatformStore from "@store/usePlatformStore";
import { useSyncMeeting } from "@screens/meeting/hooks/useSyncMeeting";
import { cn } from "@utils/tailwind.util";
import { ImageSection } from "@components/Sections";
import { MeetingInfo } from "@components/Meetings";
import { SectionHeading } from "@ui/Headings";
import { Paragraph } from "@ui/Content";
import { Button } from "@ui/Button";

export default function SyncMeetingScreen() {
  const { track } = useUserpilot();
  const { itemId, calendarId } = usePlatformStore();
  const { mutate: syncMeetingMutate, isPending } = useSyncMeeting();

  const handleSyncMeeting = () => {
    syncMeetingMutate({ itemId, calendarId });
    track("Click: Sync meeting");
  };

  return (
    <div className="flex flex-col items-center justify-center px-4">
      <ImageSection
        className={"mt-6 mb-6"}
        mainIcon={
          isPending ? (
            <MeetingSyncingIcon className="max-h-16 max-w-16 z-20 object-contain" />
          ) : (
            <MeetingSyncIcon className="max-h-16 max-w-16 z-20 object-contain" />
          )
        }
        overlayIcon={
          isPending ? (
            <RefreshIcon className="stroke-gray-550 stroke-[1.76] animate-slowpin-reverse" />
          ) : null
        }
        overlayIconBackground={"bg-white top-[0px]"}
      />

      <div className="flex flex-col gap-4 pt-2 pb-6 px-4">
        <Paragraph>Sync to add notes and tags</Paragraph>
      </div>

      <div className="flex flex-col items-center gap-[18px]">
        <Button
          className={cn(
            "min-w-[170px] h-8",
            isPending
              ? "bg-teal-100 text-white dark:bg-gray-700 dark:text-teal-100"
              : "bg-teal-500 text-white"
          )}
          buttonType={isPending ? "TRANSPARENT" : "PRIMARY"}
          onClick={handleSyncMeeting}
          disabled={isPending}
        >
          {isPending ? "Syncing Meeting" : "Sync Meeting"}
        </Button>
      </div>

      <div className="flex flex-col w-full opacity-50 pointer-events-none mt-5 gap-y-5">
        <MeetingInfo />

        <div>
          <SectionHeading>Notes</SectionHeading>
          <textarea
            className="text-sm text-gray-700 mt-3 h-[150px] w-full rounded-lg border-gray-300 px-3 py-2 resize-none dark:bg-gray-700"
            placeholder="Write your notes here..."
            disabled
          />
        </div>

        <div>
          <SectionHeading>Tags</SectionHeading>
          {!isPending && <span className="text-sm text-gray-500 mt-3">No tags yet</span>}
        </div>
      </div>

      {isPending && (
        <div className="relative w-full mt-2 mb-4 overflow-hidden rounded bg-gray-200 h-[5px]">
          <div className="absolute h-full w-1/3 bg-gradient-to-r from-transparent via-teal-500/70 to-transparent animate-bounce-bar" />
        </div>
      )}
    </div>
  );
}
